import { useState, useEffect, useCallback } from 'react';

export const useDocumentEvent = () => {
  const [isDetected, setIsDetected] = useState<boolean>(false);
  const [isEvent, setIsEvent] = useState<MouseEvent>();

  const handleHover = useCallback(
    (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      setIsEvent(event);

      if (isDetected || target.id === 'marker-event') setIsDetected(true);
    },
    [isDetected]
  );

  const handleDocumentClick = (event: MouseEvent) => {
    setIsEvent(event);
    setIsDetected(true);
  };

  const handleDocumentDrag = (event: MouseEvent) => {
    setIsEvent(event);
    setIsDetected(true);
  };

  useEffect(() => {
    document.addEventListener('mouseover', handleHover);
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('drag', handleDocumentDrag);

    return () => {
      document.removeEventListener('mouseover', handleHover);
      document.removeEventListener('drag', handleDocumentDrag);
    };
  }, [handleHover, isEvent, isDetected]);

  return { isDetected, isEvent, setIsDetected };
};
